export const clinicalPsychologyConst = {
  path: "/single-programs/clinical-psychology",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — КЛИНИЧЕСКАЯ ПСИХОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Клиническая психология — профессия, которая помогает жить</h2>
      <p>
        Клиническая психология — это не просто изучение человеческой психики. Это ключ к пониманию глубинных причин поведения, эмоций и
        психических расстройств. Это наука и искусство помощи. Профессия, где каждый день вы можете менять чью-то жизнь к лучшему.
      </p>
      <p>
        На медицинском факультете мы готовим будущих профессионалов, способных оказывать поддержку и терапевтическую помощь на самом высоком
        уровне. Обучение клинической психологии включает как теоретические дисциплины, так и практическую подготовку, необходимую для работы
        в медицинских учреждениях, центрах психотерапии и научных организациях.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Общая и клиническая психология</li>
        <li>Психопатология и диагностика психических расстройств</li>
        <li>Методы психологического консультирования</li>
        <li>Психотерапевтические подходы (когнитивно-поведенческая, психодинамическая терапия и др.)</li>
        <li>Нейропсихология</li>
        <li>Медицинская психология и психофармакология</li>
        <li>Психология кризисных состояний и травм</li>
        <li>Этические и правовые аспекты психотерапии</li>
        <li>Практика клинического интервью и психодиагностики</li>
        <li>Психология развития и семейная психология</li>
      </ul>
      <p>Программа включает практику и стажировки в клиниках, психиатрических учреждениях, реабилитационных центрах и НКО.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Клинический психолог в медицинских учреждениях</li>
        <li>Психолог-консультант в частной практике</li>
        <li>Специалист в сфере психического здоровья (в школах, центрах поддержки, хосписах)</li>
        <li>Психотерапевт (при получении дополнительной лицензии или магистратуры)</li>
        <li>Исследователь в области психологии</li>
        <li>Специалист в области корпоративного ментального здоровья</li>
        <li>Преподаватель или научный сотрудник</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Клинические психологи — одни из самых необходимых специалистов в системе здравоохранения.</p>
      <p>
        <strong>Средний доход в Европе составляет от €40,000 до €80,000 в год,</strong> при этом спрос на специалистов стабильно растёт.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, признанный в ЕС и других странах</li>
        <li>Гибкий формат обучения: очно или дистанционно</li>
        <li>Доступ к виртуальным симуляциям, клинической практике и современным методикам</li>
        <li>Программы на английском и русском языках</li>
        <li>Индивидуальный подход к обучению и менторская поддержка</li>
        <li>Партнёрство с европейскими медицинскими и психотерапевтическими учреждениями</li>
      </ul>
      <h2>Учёба, приближенная к реальности</h2>
      <p>
        Наши студенты участвуют в исследованиях, проводят реальные консультации под супервизией и проходят стажировки в международных
        учреждениях, работающих в сфере ментального здоровья.
      </p>
      <br />
      <p className="padding-left">
        «Клиническая психология — это профессия, где слушать — значит лечить. Мы обучаем не просто специалистов, а настоящих проводников к
        психическому благополучию.»
      </p>
      <h2>Как поступить?</h2>
      <p>
        Процесс поступления прост и прозрачен. Заполните анкету на сайте, загрузите документы и дождитесь обратной связи от приёмной
        комиссии. Мы сопровождаем каждого кандидата на всех этапах — от подачи заявки до начала учёбы. блок как поступить
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Клиническая психология — профессия, которая помогает жить
    Клиническая психология — это не просто изучение человеческой психики. Это ключ к пониманию глубинных причин поведения, эмоций и психических расстройств. Это наука и искусство помощи. Профессия, где каждый день вы можете менять чью-то жизнь к лучшему.
    На медицинском факультете мы готовим будущих профессионалов, способных оказывать поддержку и терапевтическую помощь на самом высоком уровне. Обучение клинической психологии включает как теоретические дисциплины, так и практическую подготовку, необходимую для работы в медицинских учреждениях, центрах психотерапии и научных организациях.

    Что вы будете изучать?
    • Общая и клиническая психология
    • Психопатология и диагностика психических расстройств
    • Методы психологического консультирования
    • Психотерапевтические подходы (когнитивно-поведенческая, психодинамическая терапия и др.)
    • Нейропсихология
    • Медицинская психология и психофармакология
    • Психология кризисных состояний и травм
    • Этические и правовые аспекты психотерапии
    • Практика клинического интервью и психодиагностики
    • Психология развития и семейная психология
    Программа включает практику и стажировки в клиниках, психиатрических учреждениях, реабилитационных центрах и НКО.

    Кем можно работать после окончания?
    • Клинический психолог в медицинских учреждениях
    • Психолог-консультант в частной практике
    • Специалист в сфере психического здоровья (в школах, центрах поддержки, хосписах)
    • Психотерапевт (при получении дополнительной лицензии или магистратуры)
    • Исследователь в области психологии
    • Специалист в области корпоративного ментального здоровья
    • Преподаватель или научный сотрудник
    Востребованность и доход
    Клинические психологи — одни из самых необходимых специалистов в системе здравоохранения.
    Средний доход в Европе составляет от €40,000 до €80,000 в год, при этом спрос на специалистов стабильно растёт.

    Почему выбирают нас?
    • Европейский диплом, признанный в ЕС и других странах
    • Гибкий формат обучения: очно или дистанционно
    • Доступ к виртуальным симуляциям, клинической практике и современным методикам
    • Программы на английском и русском языках
    • Индивидуальный подход к обучению и менторская поддержка
    • Партнёрство с европейскими медицинскими и психотерапевтическими учреждениями

    Учёба, приближенная к реальности
    Наши студенты участвуют в исследованиях, проводят реальные консультации под супервизией и проходят стажировки в международных учреждениях, работающих в сфере ментального здоровья.
    «Клиническая психология — это профессия, где слушать — значит лечить. Мы обучаем не просто специалистов, а настоящих проводников к психическому благополучию.»

    Как поступить?
    Процесс поступления прост и прозрачен. Заполните анкету на сайте, загрузите документы и дождитесь обратной связи от приёмной комиссии. Мы сопровождаем каждого кандидата на всех этапах — от подачи заявки до начала учёбы. блок как поступить
  `,
};
